export interface User {
  id: string;
  email: string;
  fullName: string;
  fullNameAr?: string;
  phone?: string;
  userType: 'client' | 'user' | 'lawyer' | 'firm_admin';
  credits: number;
  totalCreditsUsed: number;
  specialization?: string;
  specializationAr?: string;
  interests: string[];
  is_active?: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  email: string;
  password: string;
  fullName: string;
  fullNameAr?: string;
  phone?: string;
  userType: 'client' | 'user' | 'lawyer' | 'firm_admin';
  specialization?: string;
  specializationAr?: string;
  interests?: string[];
}

export interface AuthResponse {
  success: boolean;
  user?: User;
  token?: string;
  message?: string;
  error?: string;
}

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

export interface RolePermissions {
  canAccessLibrary: boolean;
  canAccessChat: boolean;
  canAccessMessenger: boolean;
  canAccessNotifications: boolean;
  canAccessLawyers: boolean;
  canAccessFirmOffices: boolean;
  canAccessSupport: boolean;
  canManageUsers: boolean;
  canManageContent: boolean;
  canViewAnalytics: boolean;
}

export const ROLE_PERMISSIONS: Record<User['userType'], RolePermissions> = {
  client: {
    canAccessLibrary: true,
    canAccessChat: true,
    canAccessMessenger: true,
    canAccessNotifications: true,
    canAccessLawyers: true,
    canAccessFirmOffices: true,
    canAccessSupport: true,
    canManageUsers: false,
    canManageContent: false,
    canViewAnalytics: false,
  },
  user: {
    canAccessLibrary: true,
    canAccessChat: true,
    canAccessMessenger: true,
    canAccessNotifications: true,
    canAccessLawyers: true,
    canAccessFirmOffices: true,
    canAccessSupport: true,
    canManageUsers: false,
    canManageContent: false,
    canViewAnalytics: false,
  },
  lawyer: {
    canAccessLibrary: true,
    canAccessChat: true,
    canAccessMessenger: true,
    canAccessNotifications: true,
    canAccessLawyers: true,
    canAccessFirmOffices: true,
    canAccessSupport: true,
    canManageUsers: false,
    canManageContent: false,
    canViewAnalytics: false,
  },
  firm_admin: {
    canAccessLibrary: true,
    canAccessChat: true,
    canAccessMessenger: true,
    canAccessNotifications: true,
    canAccessLawyers: true,
    canAccessFirmOffices: true,
    canAccessSupport: true,
    canManageUsers: true,
    canManageContent: false,
    canViewAnalytics: false,
  },
};
